module.exports = __webpack_public_path__ + "images/search.26a98aa8.png";